var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24385 0.353701C6.49312 0.10443 6.89727 0.10443 7.14654 0.353701C7.39581 0.602972 7.39581 1.00712 7.14654 1.25639L2.49151 5.91143L5.44442 8.86434C5.69369 9.11361 5.69369 9.51776 5.44442 9.76703C5.19514 10.0163 4.791 10.0163 4.54173 9.76703L1.13747 6.36277C0.8882 6.1135 0.8882 5.70935 1.13747 5.46008L6.24385 0.353701ZM6.7085 11.6295C6.36332 11.6295 6.0835 11.3497 6.0835 11.0045C6.0835 10.6593 6.36332 10.3795 6.7085 10.3795C7.05367 10.3795 7.3335 10.6593 7.3335 11.0045C7.3335 11.3497 7.05367 11.6295 6.7085 11.6295Z",
    fill: "#191818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.5f029cc2c23111e0de0fe1703e232643.svg";
export { ForwardRef as ReactComponent };